import { render, staticRenderFns } from "./FrontSettings.vue?vue&type=template&id=fea837d4"
import script from "./FrontSettings.vue?vue&type=script&lang=js"
export * from "./FrontSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports